#import "./fragments/personFragment.graphql"
#import "./fragments/personFilledPositionsFragment.graphql"
#import "./fragments/teamFragment.graphql"
#import "./fragments/tagFragment.graphql"

fragment GlobalSearchResultsFragment on GlobalSearch {
  pagedPeople @include(if: $includePeople) {
    totalCount
    searchAfterId
    people {
      ...GlobalSearchPersonBaseFragment
      ...PersonFilledPositionsFragment @include(if: $includePositionFields)
      __typename
    }
    __typename
  }

  pagedPositions @include(if: $includePositions) {
    totalCount
    positions {
      id
      occupancyStatus
      startDate
      endDate
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
        isVacancy
        __typename
      }
      incumbents {
        aggregateId
        preferredName
        firstName
        surname
        avatar
        __typename
      }
      supplyTeam {
        id
        name
        type
        __typename
      }
      __typename
    }
    __typename
  }

  pagedGroups @include(if: $includeGroups) {
    totalCount
    groups {
      ...TeamFragment
      __typename
    }
    __typename
  }

  pagedTags @include(if: $includeTags) {
    totalCount
    tags {
      ...TagMinimalFragment
      __typename
    }
    __typename
  }
}

query globalSearchQuery(
  $searchTerms: [String]
  $size: Int
  $filter: InsightFilter
  $includePeople: Boolean! = true
  $includeGroups: Boolean! = true
  $includeTags: Boolean! = false
  $includePositions: Boolean! = false
  $includePositionFields: Boolean = false
  $personFieldsToSearch: [PersonFieldsToSearch]
  $positionFieldsToSearch: [PersonFieldsToSearch]
  $positionOccupancyStatus: [PositionOccupancyStatus!]
  $groupFieldsToSearch: [GroupFieldsToSearch]
  $tagFieldsToSearch: [TagFieldsToSearch]
  $personSearchAfterId: [String]
  $tagsOffset: Int = 0
  $groupsOffset: Int = 0
  $positionsPage: Int
  $includeEmptyGroups: Boolean = false
) {
  result: globalSearch(
    tagsOffset: $tagsOffset
    groupsOffset: $groupsOffset
    positionsPage: $positionsPage
    positionOccupancyStatus: $positionOccupancyStatus
    positionFieldsToSearch: $positionFieldsToSearch
    size: $size
    searchTerms: $searchTerms
    filter: $filter
    personFieldsToSearch: $personFieldsToSearch
    groupFieldsToSearch: $groupFieldsToSearch
    tagFieldsToSearch: $tagFieldsToSearch
    personSearchAfterId: $personSearchAfterId
    includeTags: $includeTags
    includePeople: $includePeople
    includeGroups: $includeGroups
    includePositions: $includePositions
    includeEmptyGroups: $includeEmptyGroups
  ) {
    ...GlobalSearchResultsFragment
  }
}

# globalSearch cannot return hidden teams, so the opt-in admin filter goes
# straight to listGroups instead. That is the same call globalSearch makes for
# its own team results, and it has accepted includeHiddenGroups for a long time,
# so this needs no API change. Only the teams section uses this query; people,
# positions and tags keep using globalSearchQuery above.
query searchHiddenGroupsQuery(
  $searchTerms: [String]
  $size: Int
  $groupsOffset: Int = 0
  $groupTypes: [String]
  $groupIds: [String]
  $includeDescendants: Boolean = false
  $includeHiddenGroups: Boolean! = true
  $includeEmptyGroups: Boolean = true
) {
  pagedGroups: listGroups(
    search: $searchTerms
    groupTypes: $groupTypes
    groupIds: $groupIds
    groupKinds: ["team"]
    includeDescendants: $includeDescendants
    includeEmptyGroups: $includeEmptyGroups
    includeHiddenGroups: $includeHiddenGroups
    includeDeletedGroups: false
    includeTotalCount: true
    limit: $size
    offset: $groupsOffset
  ) {
    totalCount
    groups {
      ...TeamFragment
      __typename
    }
    __typename
  }
}
